import React, { useState, useEffect } from 'react';
import code_editor from '../../../assets/svgComponent/codeEditor.svg';
import logger from './../../../utils/logger.js';


const ControlPanel = ({ 
  isMobile, 
  handleEndCall, 
  isCodeEditorEnabled, 
  handleEditorToggle,
  handleExcalidrawOpen, 
  handleExcalidrawClose,
  showEditor,
  showExcalidraw,
  editorButtonStyle 
}) => {
  // Local state to ensure buttons are shown even if props are not immediately available
  const [shouldShowTechButtons, setShouldShowTechButtons] = useState(isCodeEditorEnabled);
  
  // Check localStorage for interview category to ensure buttons display after refresh
  useEffect(() => {
    const storedCategory = localStorage.getItem("interviewCategory");
    logger.debug("ControlPanel - Retrieved interview category from localStorage:", storedCategory);
    
    if (storedCategory === 'TECH') {
      logger.debug("ControlPanel - Enabling tech buttons based on localStorage category");
      setShouldShowTechButtons(true);
    }
  }, []);
  
  // Update local state if prop changes
  useEffect(() => {
    if (isCodeEditorEnabled) {
      setShouldShowTechButtons(true);
    }
  }, [isCodeEditorEnabled]);

  return (
    <div style={{
      height: isMobile ? 'auto' : '10vh',
      background: isMobile ? 'rgba(39, 39, 42, 0.8)' : '#27272a',
      display: 'flex',
      width: isMobile ? 'auto' : '100vw',
      position: 'fixed',
      bottom: isMobile ? '10px' : 0,
      right: isMobile ? '10px' : 'auto',
      left: isMobile ? 'auto' : 0,
      justifyContent: 'center',
      alignItems: 'center',
      padding: isMobile ? '10px' : '0 20px',
      zIndex: 1000,
      borderRadius: isMobile ? '50px' : '12px 12px 0 0',
      backdropFilter: isMobile ? 'blur(8px)' : 'none',
      boxShadow: isMobile ? '0 4px 12px rgba(0, 0, 0, 0.2)' : 'none'
    }}>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: isMobile ? '10px' : '20px'
      }}>
        {/* Excalidraw Button - Only show for tech interviews */}
        {/* (shouldShowTechButtons || isCodeEditorEnabled) && (
          <button
            onClick={handleExcalidrawOpen}
            style={{
              background: showExcalidraw ? '#007bff' : '#4b5563',
              border: 'none',
              cursor: 'pointer',
              padding: isMobile ? '6px' : '8px',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'all 0.2s',
            }}
            onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
            onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
            title={showExcalidraw ? "Close Whiteboard" : "Open Whiteboard"}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width={isMobile ? 20 : 28} height={isMobile ? 20 : 28} viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M3 3h18v18H3z" opacity="0"></path>
              <path d="M14 3v4a1 1 0 0 0 1 1h4"></path>
              <path d="M17 21h-7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4l5 5v11a2 2 0 0 1-2 2z"></path>
              <path d="M10 12h4"></path>
              <path d="M10 16h4"></path>
            </svg>
          </button>
        ) */}
        
        {/* Replace the image with an embedded SVG */}
        <svg 
          width={isMobile ? 36 : 64} 
          height={isMobile ? 22 : 40} 
          viewBox="0 0 66 42" 
          fill="none" 
          xmlns="http://www.w3.org/2000/svg"
          onClick={handleEndCall}
          style={{
            cursor: 'pointer',
            transition: 'transform 0.2s'
          }}
          onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
          onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
        >
          <g filter="url(#filter0_d_41_928)">
            <rect x="1" y="1" width="64" height="40" rx="20" fill="#DC2626"/>
            <rect x="1" y="1" width="64" height="40" rx="20" fill="url(#paint0_linear_41_928)"/>
            <rect x="1.5" y="1.5" width="63" height="39" rx="19.5" stroke="#F87171"/>
            <g filter="url(#filter1_d_41_928)">
              <path d="M43.1515 24.1726C42.9532 24.426 42.6786 24.609 42.3683 24.6944C42.058 24.7798 41.7285 24.7632 41.4284 24.647L36.8346 23.0166L36.8074 23.0063C36.5777 22.9144 36.3743 22.7671 36.2153 22.5775C36.0563 22.388 35.9467 22.162 35.8962 21.9198L35.314 19.1307C33.8036 18.6161 32.1647 18.6197 30.6565 19.141L30.1034 21.9085C30.0546 22.1534 29.9454 22.3823 29.7858 22.5743C29.6262 22.7663 29.4212 22.9155 29.1893 23.0082L29.1621 23.0185L24.5684 24.647C24.3979 24.7142 24.2164 24.7491 24.0331 24.7501C23.8049 24.7505 23.5797 24.6989 23.3745 24.5991C23.1693 24.4994 22.9896 24.3541 22.849 24.1745C21.2337 22.0913 21.4146 19.3267 23.2887 17.4517C28.5528 12.1857 37.4449 12.1857 42.7118 17.4517C44.5859 19.3248 44.7668 22.0895 43.1515 24.1726ZM41.2503 27.0001H24.7503C24.5513 27.0001 24.3606 27.0791 24.2199 27.2198C24.0793 27.3604 24.0003 27.5512 24.0003 27.7501C24.0003 27.949 24.0793 28.1398 24.2199 28.2804C24.3606 28.4211 24.5513 28.5001 24.7503 28.5001H41.2503C41.4492 28.5001 41.6399 28.4211 41.7806 28.2804C41.9212 28.1398 42.0003 27.949 42.0003 27.7501C42.0003 27.5512 41.9212 27.3604 41.7806 27.2198C41.6399 27.0791 41.4492 27.0001 41.2503 27.0001Z" fill="white"/>
            </g>
          </g>
          <defs>
            <filter id="filter0_d_41_928" x="0" y="0" width="66" height="42" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
              <feFlood flood-opacity="0" result="BackgroundImageFix"/>
              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
              <feMorphology radius="1" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_41_928"/>
              <feOffset/>
              <feComposite in2="hardAlpha" operator="out"/>
              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"/>
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_41_928"/>
              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_41_928" result="shape"/>
            </filter>
            <filter id="filter1_d_41_928" x="21" y="9" width="24" height="25" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
              <feFlood flood-opacity="0" result="BackgroundImageFix"/>
              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
              <feOffset dy="1"/>
              <feComposite in2="hardAlpha" operator="out"/>
              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"/>
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_41_928"/>
              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_41_928" result="shape"/>
            </filter>
            <linearGradient id="paint0_linear_41_928" x1="33" y1="1" x2="33" y2="41" gradientUnits="userSpaceOnUse">
              <stop stop-color="white" stop-opacity="0.24"/>
              <stop offset="1" stop-opacity="0"/>
            </linearGradient>
          </defs>
        </svg>
        
        {/* (shouldShowTechButtons || isCodeEditorEnabled) && (
          <button
            onClick={handleEditorToggle}
            style={{
              background: '#4b5563',
              border: 'none',
              cursor: 'pointer',
              padding: isMobile ? '6px' : '8px',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'all 0.2s',
            }}
            onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
            onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
            title={showEditor ? "Minimize Code Editor" : "Open Code Editor"}
          >
            <img
              src={code_editor}
              width={isMobile ? 24 : 32}
              height={isMobile ? 24 : 32}
              alt="Code Editor"
            />
          </button>
        ) */}
      </div>
    </div>
  );
};

export default ControlPanel;